import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import { Breakpoint, Button, useBreakpoint } from '@genially/design-system';
import { LiveIcon } from '@genially/icons';

import { useModal } from '../../../../../../../../bootstrap/application/components/app/components/ModalProvider/ModalProvider.context';
import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { NoPlayersModal } from '../NoPlayersModal/NoPlayersModal';
import { ButtonWrapper } from './StartButton.styled';

export const StartButton = observer(() => {
  const t = useTranslate();
  const { client } = useHostClientContext();

  const { openModal, closeModal } = useModal();

  const { isDownwards } = useBreakpoint();

  const isMobile = isDownwards(Breakpoint.xs);

  const hasPlayers = client.players.length > 0;

  const handleStartGame = () => {
    client.startGame();
  };

  const handleStartGameButtonClick = () => {
    if (!hasPlayers) {
      openModal(parentElement => (
        <NoPlayersModal
          parentElement={parentElement}
          closeModal={closeModal}
          onConfirm={handleStartGame}
        />
      ));

      return;
    }

    handleStartGame();
  };

  return (
    <ButtonWrapper $animate={hasPlayers}>
      <Button
        StartIcon={<LiveIcon />}
        onClick={handleStartGameButtonClick}
        size={isMobile ? Button.Size.MEDIUM : Button.Size.BIG}
        width={isMobile ? '100%' : 'auto'}
        variant={hasPlayers ? Button.Variant.CTA : Button.Variant.DEFAULT}
      >
        {t('__new.play.creatorLobby.join.startButton')}
      </Button>
    </ButtonWrapper>
  );
});
